// extracted by mini-css-extract-plugin
export default {"Shadow":"_Shadow--QyKdc","ShadowOnHover":"_ShadowOnHover--H93bS","animate-gradient":"_animate-gradient--zE9yC"};